export default __webpack_public_path__ + "static/media/copper fluted panel.808f54e4.png";